import { render, staticRenderFns } from "./GenericChildManager.vue?vue&type=template&id=f8da0510&scoped=true"
import script from "./GenericChildManager.vue?vue&type=script&lang=ts"
export * from "./GenericChildManager.vue?vue&type=script&lang=ts"
import style0 from "./GenericChildManager.vue?vue&type=style&index=0&id=f8da0510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8da0510",
  null
  
)

export default component.exports